"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyAddressInput = instanceOfPropertyAddressInput;
exports.PropertyAddressInputFromJSON = PropertyAddressInputFromJSON;
exports.PropertyAddressInputFromJSONTyped = PropertyAddressInputFromJSONTyped;
exports.PropertyAddressInputToJSON = PropertyAddressInputToJSON;
exports.PropertyAddressInputToJSONTyped = PropertyAddressInputToJSONTyped;
var SuburbInput_1 = require("./SuburbInput");
/**
 * Check if a given object implements the PropertyAddressInput interface.
 */
function instanceOfPropertyAddressInput(value) {
    return true;
}
function PropertyAddressInputFromJSON(json) {
    return PropertyAddressInputFromJSONTyped(json, false);
}
function PropertyAddressInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'buildingName': json['buildingName'] == null ? undefined : json['buildingName'],
        'level': json['level'] == null ? undefined : json['level'],
        'unitNumber': json['unitNumber'] == null ? undefined : json['unitNumber'],
        'streetNumber': json['streetNumber'] == null ? undefined : json['streetNumber'],
        'street': json['street'] == null ? undefined : json['street'],
        'suburb': json['suburb'] == null ? undefined : (0, SuburbInput_1.SuburbInputFromJSON)(json['suburb']),
    };
}
function PropertyAddressInputToJSON(json) {
    return PropertyAddressInputToJSONTyped(json, false);
}
function PropertyAddressInputToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'buildingName': value['buildingName'],
        'level': value['level'],
        'unitNumber': value['unitNumber'],
        'streetNumber': value['streetNumber'],
        'street': value['street'],
        'suburb': (0, SuburbInput_1.SuburbInputToJSON)(value['suburb']),
    };
}
